import { KB_SOURCE, TYPE_FOLDER } from "util/constants";

import { FileData } from "@/util/interfaces/FileData";
import { getUserInfo } from "@/utils/session";

interface FileAttributes {
  [key: string]: {
    category: string;
    metadata: string;
    path: string;
    fileName: string;
    uuid?: string;
  };
}

interface FileItem {
  file: File;
  category: string;
  metadata?: string;
  isFolder?: string;
  path?: string;
  files?: FileItem[];
  uuid?: string;
}

export const addToRequest = (
  attributes: FileAttributes,
  files: FileItem[],
  selectedFolder: string
) => {
  for (const item of files) {
    if (item.isFolder === TYPE_FOLDER) {
      addFolderToRequest(attributes, item, selectedFolder);
    } else {
      attributes[item.file.name] = {
        category: item.category,
        metadata: item.metadata ?? "",
        path: selectedFolder === "" ? "" : selectedFolder + "/",
        fileName: item.file.name,
      };
    }
  }
};

export const addFolderToRequest = (
  attributes: FileAttributes,
  file: FileItem,
  selectedFolder: string
) => {
  if (!file.files) return;

  for (const f of file.files) {
    if (f.isFolder === TYPE_FOLDER) {
      addFolderToRequest(attributes, f, selectedFolder);
    } else {
      const path = selectedFolder === "" ? "" : selectedFolder + "/";
      attributes[f.file.name] = {
        category: f.category,
        metadata: f.metadata ?? "",
        path: path + (f.path ?? ""),
        fileName: f.file.name,
      };
    }
  }
};
export const processPath = (existingPath: string): string => {
  if (existingPath === "") {
    return "";
  }
  if (existingPath.endsWith("/")) {
    return existingPath;
  }
  return existingPath + "/";
};
export const createUploadRequest = (files: FileData[]): FormData => {
  const sendData = new FormData();
  const attributes: { [key: string]: any } = {};
  const { nameUser: userName, userId } = getUserInfo();

  for (const item of files) {
    sendData.append(`files`, item.file);
    attributes[item.file.name] = {
      category: item.fileCategory,
      metadata: item.metadata,
      path: item.path,
      uuid: item.uuid,
    };
  }

  sendData.append(
    "blob_metadata_dict",
    JSON.stringify({
      attributes,
      upload_by: userName,
      user_uuid: userId,
      source: KB_SOURCE,
    })
  );
  return sendData;
};
